// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-breakpoint-4k: 3840px;
    --ds-breakpoint-full-hd: 1920px;
    --ds-breakpoint-desktop-standard: 1140px;
    --ds-breakpoint-desktop-small: 1280px;
    --ds-breakpoint-tablet-landscape: 1024px;
    --ds-breakpoint-tablet-portrait: 768px;
    --ds-breakpoint-smartphone-landscape: 800px;
    --ds-breakpoint-smartphone-portrait: 360px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
